import { useState } from "react"

export const useRequestParameter = (name: string, defaultValue: string) => {
    const [param] = useState<string>(() => {
        const regexResult = new RegExp('[?&]'+encodeURIComponent(name)+'=([^&]*)').exec(window.location.search)
        return (regexResult && regexResult.length > 1) ? regexResult[1]: defaultValue;
    })
    return param;
}